import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Button } from "@/components/ui/button";
import { Leaf, Truck, HeartHandshake, ShoppingBasket } from "lucide-react";

const HERO = "https://images.pexels.com/photos/34387507/pexels-photo-34387507.jpeg";

export default function About() {
  usePageMeta("About Us", "Learn about Nicee — quality groceries delivered fast to your doorstep.");
  return (
    <div>
      <section className="relative overflow-hidden border-b border-border/60">
        <img src={HERO} alt="Farm at sunrise" className="h-[300px] w-full object-cover sm:h-[380px]" />
        <div className="absolute inset-0 bg-ink/50" />
        <div className="absolute inset-0 mx-auto flex max-w-7xl flex-col justify-center px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-4xl font-black text-cream sm:text-5xl">Our Story</h1>
          <p className="mt-3 max-w-xl text-cream/85">From trusted local farms straight to your family's table.</p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        <p className="text-lg leading-relaxed text-ink-soft">
          Nicee started with a simple belief: everyone deserves genuinely fresh groceries and daily essentials,
          delivered fast. We work directly with trusted local suppliers and bring quality products to your
          doorstep within hours — so what lands in your kitchen is always fresh.
        </p>
        <p className="mt-6 text-lg leading-relaxed text-ink-soft">
          No long supply chains, no compromises on quality. Just clean, wholesome essentials, honest
          pricing, and the convenience of Cash on Delivery.
        </p>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
          {[
            { icon: Leaf, t: "Farm Freshness", d: "Sourced and delivered daily — never stored for days." },
            { icon: Truck, t: "Doorstep Delivery", d: "Fast local delivery right to your home." },
            { icon: HeartHandshake, t: "Honest & Simple", d: "Fair prices and easy Cash on Delivery." },
          ].map((v) => (
            <div key={v.t} className="rounded-2xl border border-border/60 bg-white p-6 shadow-ambient">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand/10 text-brand">
                <v.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-heading text-lg text-ink">{v.t}</h3>
              <p className="mt-1 text-sm text-ink-soft">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center rounded-[2rem] bg-cream-alt/70 p-10 text-center">
          <ShoppingBasket className="h-10 w-10 text-brand" />
          <h2 className="mt-4 font-heading text-2xl font-bold text-ink">Ready to shop?</h2>
          <Link to="/products">
            <Button className="mt-5 rounded-full bg-brand px-8 text-ink hover:bg-brand-hover">Shop Now</Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
